import React from "react";

// Olive-drop mark — the Suhool brand signature
export default function LogoMark({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <path d="M12 21.5c-4.2 0-7.2-3-7.2-7.2 0-5.2 3.2-9.4 7.2-12.3 4 2.9 7.2 7.1 7.2 12.3 0 4.2-3 7.2-7.2 7.2Z"
        stroke="currentColor" strokeWidth="1.5" />
      <path d="M12 21.5V10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M12 13.5c-2-.5-3.6-2-4.1-4.1M12 17.5c2-.5 3.6-2 4.1-4.1"
        stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
  );
}
